import { Button } from "../components/Button";
import { IdCapturePanel } from "../components/IdCapturePanel";
import { TrustCallout } from "../components/TrustCallout";
import { VerifyStepList } from "../components/VerifyStepList";
import { useFlow } from "../flow/FlowContext";
import { PHOTO_MAX, PHOTO_MIN } from "../media/limits";
import { useT } from "../i18n";

export function VerifyIdScreen() {
  const { answers, setGovernmentId, next, canContinue, userId } = useFlow();
  const t = useT();

  return (
    <>
      <div
        className="screen-enter"
        style={{ flex: 1, display: "flex", flexDirection: "column", gap: 18 }}
      >
        <header className="screen-head">
          <div className="screen-head__eyebrow">{t("verify.id.eyebrow")}</div>
          <h1 className="screen-head__title">{t("verify.id.title")}</h1>
          <p className="screen-head__text">{t("verify.id.text")}</p>
        </header>
        <VerifyStepList
          statuses={{
            id: "active",
            video: "pending",
            photos: "pending",
            review: "pending",
          }}
        />
        <IdCapturePanel
          asset={answers.governmentId}
          userId={userId ?? ""}
          onChange={setGovernmentId}
        />
        {answers.governmentId ? (
          <TrustCallout title={t("verify.id.savedTitle")}>
            {t("verify.id.savedBody", { min: PHOTO_MIN, max: PHOTO_MAX })}
          </TrustCallout>
        ) : null}
      </div>
      <div className="shell__footer" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Button onClick={next} disabled={!canContinue}>
          {t("common.continue")}
        </Button>
      </div>
    </>
  );
}
